const WeatherSourceSummaryCards = ({ summary }) => {
  if (!summary) {
    return null;
  }

  const cards = [
    { label: "Total sources", value: summary.totalSources ?? 0 },
    {
      label: "Healthy",
      value: summary.healthySources ?? 0,
      tone: "green",
    },
    {
      label: "Stale / warning",
      value: summary.staleSources ?? 0,
      tone: summary.staleSources > 0 ? "amber" : null,
    },
    {
      label: "Down",
      value: summary.downSources ?? 0,
      tone: summary.downSources > 0 ? "red" : null,
    },
    {
      label: "Experimental",
      value: summary.experimentalSources ?? 0,
    },
    {
      label: "Historical / archive",
      value: summary.historicalSources ?? 0,
    },
  ];

  return (
    <section className="admin-dashboard__kpis">
      {cards.map((card) => (
        <div className="admin-dash__kpi-card" key={card.label}>
          <span className="admin-dash__kpi-label">{card.label}</span>
          <span
            className={`admin-dash__kpi-value${
              card.tone ? ` admin-dash__kpi-value--${card.tone}` : ""
            }`}
          >
            {card.value}
          </span>
        </div>
      ))}
    </section>
  );
};

export default WeatherSourceSummaryCards;
